import cn from 'mxcn';
import { IconSparkles } from './icons';
import { CustomStylesI } from '.';
import { useIsDarkMode } from './hooks/use-is-dark-mode';

export function AiLoader({ customStyles }: { customStyles?: CustomStylesI }) {
	const isDarkMode = useIsDarkMode();
	return (
		<div className={cn('lb-group lb-relative lb-flex lb-items-start')}>
			<div
				className={cn(
					'lb-flex lb-size-8 lb-select-none lb-items-center lb-justify-center lb-rounded-xl lb-border lb-border-muted-foreground/40 lb-shadow',
					'lb-bg-primary lb-text-primary-foreground'
				)}
				style={{
					...(customStyles?.chatbot?.foregroundColor && {
						backgroundColor: !isDarkMode
							? customStyles?.chatbot?.foregroundColor
							: customStyles?.chatbot?.backgroundColor,
						color: !isDarkMode
							? customStyles?.chatbot?.backgroundColor
							: customStyles?.chatbot?.foregroundColor
					})
				}}
			>
				<IconSparkles className="lb-size-4" />
			</div>
			<div
				className="lb-ml-4 lb-flex-1 lb-overflow-hidden lb-px-1 lb-relative lb-text-muted-foreground lb-prose dark:lb-prose-invert lb-animate-pulse"
				style={{
					...(customStyles?.chatbot?.foregroundColor && {
						color: !isDarkMode
							? customStyles?.chatbot?.foregroundColor
							: customStyles?.chatbot?.backgroundColor
					})
				}}
			>
				<p>AI is thinking...</p>
			</div>
		</div>
	);
}
